
import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'
import { removeHtml, diagramToAnalyticsItem } from '@/utils/helpers'
import analytics from '@/mixins.js/analytics'
Vue.use(VueObserveVisibility)

export default {
  filters: {
    truncate (data, num) {
      const truncatedString = data.split('').slice(0, num).join('')
      return truncatedString
    }
  },
  mixins: [analytics],
  transition: 'page',
  async asyncData ({ $backend, params }) {
    const query = removeHtml(params.query)
    const { results, next, count } = await $backend.search.get({ search: query })
    return { slides: results, query, next, page: 1, count }
  },
  data () {
    return {
      category: {
        id: 'search'
      },
      loading: false,
      ordering: '',
      query: null,
      listName: 'Search',
      tags: '',
      activeElementsIndex: 0,
      searchLabels: {
        diagramWhat: 'List',
        diagramWhere: 'Structure',
        diagramHow: 'Flowchart'
      }
    }
  },
  head () {
    return {
      title: `${this.$route.params.query} | Search results`,
      bodyAttrs: {
        class: 'page-search'
      }
    }
  },
  computed: {
    searchParams () {
      return {
        search: this.query,
        ordering: this.ordering,
        page: this.page,
        tags: this.tags
      }
    },
    trimmedQuery () {
      const reg = /(\d+)_items/
      return this.query.replace(reg, '').trim()
    }
  },
  watch: {
    ordering () {
      this.loadItems()
    },
    tags () {
      this.loadItems()
    },
    slides (slides, visibleSlides) {
      const addedSlides = slides.filter(
        slide => visibleSlides.find(s => s.id === slide.id) !== undefined
      ).filter(
        slide => slide.diagrams.length > 0
      )
      this.trackDiagramImpressions(addedSlides)
    }
  },
  mounted () {
    this.$gtag.event(
      'search', {
        event_category: 'engagement',
        event_label: this.query
      }
    )
    this.$gtag.event(
      'page_view', {
        page_location: `/search?q=${this.query}`
      }
    )
    this.trackDiagramImpressions(this.slides)
  },
  methods: {
    loadItems () {
      this.page = 1
      this.slides = []
      this.loading = true
      this.next = null
      this.$backend.search.get(this.searchParams).then(
        (data) => {
          this.slides = data.results
          this.next = data.next
          this.loading = false
        }
      )
    },
    orderChange (event) {
      this.ordering = event.target.value
    },
    toggleTags (param, index) {
      this.searchParams.required_keywords = param
      this.loadItems()
      this.activeElementsIndex = index
    },
    trackDiagramImpressions (slides) {
      const diagrams = slides.map(s => s.diagrams[0])
      const uniqueDiagrams = [...new Map(diagrams.map(v => [v.id, v])).values()]
      try {
        this.$gtag.event('view_item_list', {
          items: uniqueDiagrams.map(diagram => ({
            ...diagramToAnalyticsItem(diagram),
            list_name: this.listName
          }))
        })
        this.$bing && this.$bing.event(
          {
            ecomm_query: this.query,
            ecomm_prodid: uniqueDiagrams.map(d => d.name.slice(0, 50)),
            ecomm_pagetype: 'searchresults'
          },
          'view_item_list'
        )
      } catch (error) {
        console.error(error)
      }
    },
    async loadMoreSlides (isVisible) {
      if (isVisible && !this.loading && this.next) {
        this.next = null
        this.loading = true
        this.page += 1
        const response = await this.$backend.search.get(this.searchParams)
        this.loading = false
        this.next = response.next
        this.slides = [...this.slides, ...response.results]
      }
    }
  }
}
